import React from 'react';
import { Button } from './ui/button';
import { ChatCircle, Scales } from '@phosphor-icons/react';

const LPHeader = ({ onOpenModal }) => {
  return (
    <header className="bg-white/80 backdrop-blur-xl shadow-sm sticky top-0 z-50 border-b border-slate-200/50">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2.5">
              <Link to="/" className="flex items-center gap-2.5" data-testid="navbar-logo">
           
             <img src="/assets/img/brand/logo-dark.png" alt="Logo" className="h-10" />
          </Link>
          </div>
          <div className="flex items-center gap-2 sm:gap-3">
            <Button data-testid="lp-header-register-btn"
              onClick={() => onOpenModal && onOpenModal('Register My Trademark - Header')}
              className="bg-[#044B3B] hover:bg-[#03392D] text-white font-semibold px-3 sm:px-6 py-2 text-xs sm:text-sm rounded-md">
              Register My Trademark
            </Button>
            <Button data-testid="lp-header-chat-btn"
              onClick={() => window.cd360Api && window.cd360Api.liveChat.showWebWidget()}
              className="hidden sm:flex bg-transparent border border-slate-300 text-slate-700 hover:border-[#044B3B] hover:text-[#044B3B] font-medium px-4 py-2 rounded-md items-center gap-2 text-sm">
              <ChatCircle className="h-4 w-4" weight="bold" />
              <span>Chat Now</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LPHeader;
